import { useEffect, useMemo, useState } from 'react';

/**
 * Breakpoints de UI (mobile / tablet / desktop) basados en viewport.
 * Evita overflow horizontal cuando hay layouts con columnas fijas.
 */
export function useBreakpoints() {
  const getWidth = () => (typeof window !== 'undefined' ? window.innerWidth : 1200);
  const [width, setWidth] = useState(getWidth);

  useEffect(() => {
    const onResize = () => setWidth(getWidth());
    window.addEventListener('resize', onResize, { passive: true });
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return useMemo(() => {
    const isMobile = width <= 640;
    const isTablet = width > 640 && width <= 1024;
    const isDesktop = width > 1024;
    return { width, isMobile, isTablet, isDesktop };
  }, [width]);
}

